"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgToolsOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.tools_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "tools_outline_svg__transparent_box" },
            React.createElement("path", { className: "tools_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "tools_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "tools_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M3 11v1h5v16h7V12h4V4h-9a7 7 0 00-7 7zm10 15h-3V12h3zm4-16H5.1A5 5 0 0110 6h7zM25 15V4h-2v11h-3v8.24c0 3.93 2.17 4.76 4 4.76a3.76 3.76 0 002.78-1A5 5 0 0028 23.24V15zm1 8.24a3.31 3.31 0 01-.62 2.32A2 2 0 0124 26c-1 0-2-.22-2-2.76V17h4z" }))));
}
exports.default = SvgToolsOutline;
//# sourceMappingURL=ToolsOutline.js.map